import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import LocationString from './LocationString.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'locationString',
    multi: false
  })
)
export class FormStringLocationStringFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(LocationString);
    return this;
  }

  @Widget.Method()
  public async changeOne(value, location, title) {
    this.formData.addressTitle = title;
    this.formData.address = value;
    this.formData.position = location;
  }
}
